import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogFooter,
  DialogHeader,
  DialogPanel,
  DialogPopup,
  DialogTitle,
  Icon,
  Textarea,
} from "@salestrak/ui";

import { useSubmitFeedback } from "#app/lib/hooks/use-submit-feedback";

interface FeedbackDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * "Help us improve" — one dialog for every breakpoint. `bottomStickOnMobile`
 * (the DialogPopup default) gives it a sheet-like mobile presentation.
 */
export function FeedbackDialog({ open, onOpenChange }: FeedbackDialogProps) {
  const [message, setMessage] = useState("");
  const { submitFeedback, loading: submitting } = useSubmitFeedback();

  function handleClose() {
    setMessage("");
    onOpenChange(false);
  }

  async function handleSubmit() {
    const trimmed = message.trim();
    if (!trimmed) return;
    if (await submitFeedback(trimmed)) handleClose();
  }

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogPopup>
        <DialogHeader>
          <Box direction="row" align="center" gap="sm">
            <Icon color="primary" name="message-square" size="sm" />
            <DialogTitle>Help us improve</DialogTitle>
          </Box>
        </DialogHeader>
        <DialogPanel>
          <Textarea
            disabled={submitting}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Tell us what you think — or what is broken."
            rows={4}
            value={message}
          />
        </DialogPanel>
        <DialogFooter>
          <Button disabled={submitting} onClick={handleClose} variant="outline">
            Cancel
          </Button>
          <Button
            disabled={!message.trim()}
            loading={submitting}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogFooter>
      </DialogPopup>
    </Dialog>
  );
}
